import { Box, Tooltip, TooltipProps } from '@mui/material'
import { Permissions } from 'c1gen/permissions'
import { C1IconButton } from 'c1ui'
import { C1Icon } from 'components/core/icons/C1Icon'
import { usePermissionChecker } from 'components/no-ui/capability'
import { ScrollText } from 'lucide-react'
import { FC } from 'react'

type C1LogButtonProps = {
    title: string
    placement?: TooltipProps['placement']
    onClick: () => void
    permission?: Permissions
}

/**
 * A simple button that displays a receipt icon and triggers a click event. Meant
 * for showing logs and other types of history.
 *
 * @param {string} props.title - A string for the tooltip and aria-label
 * @param {() => void} props.onClick - A function to be called when the button is clicked
 * @returns {React.ReactNode} The rendered C1LogButton component
 */
export const C1LogButton: FC<C1LogButtonProps> = ({
    title,
    onClick,
    placement = 'bottom',
    permission,
}) => {
    const hasPermission = usePermissionChecker()

    if (permission && !hasPermission(permission)) {
        return null
    }

    return (
        <Tooltip
            title={title}
            placement={placement}
        >
            <Box>
                <C1IconButton
                    onClick={onClick}
                    aria-label={title}
                    color="info"
                    variant="outlined"
                >
                    <C1Icon icon={ScrollText} />
                </C1IconButton>
            </Box>
        </Tooltip>
    )
}
